import { Navigate, Route, Routes } from 'react-router-dom';
import NetworkCirclesPage from '@/pages/network/NetworkCirclesPage';
import GroupPage from '@/pages/network/GroupPage';
import NetworkRfqPage from '@/pages/network/NetworkRfqPage';
import NetworkDirectoryPage from '@/pages/network/NetworkDirectoryPage';
import NetworkConnectionsPage from '@/pages/network/NetworkConnectionsPage';
import NetworkMessagesPage from '@/pages/network/NetworkMessagesPage';
import NetworkChannelsPage from '@/pages/network/NetworkChannelsPage';
import NetworkAlliancePage from '@/pages/network/NetworkAlliancePage';
import LogisticsNetworkCapabilityPage from '@/pages/network/LogisticsNetworkCapabilityPage';

export default function NetworkRoutes() {
  return (
    <Routes>
      <Route index element={<Navigate to="/network/directory" replace />} />
      <Route path="directory" element={<NetworkDirectoryPage />} />
      <Route path="connections" element={<NetworkConnectionsPage />} />
      <Route path="messages" element={<NetworkMessagesPage />} />
      <Route path="messages/:memberId" element={<NetworkMessagesPage />} />
      <Route path="channels" element={<NetworkChannelsPage />} />
      <Route path="channels/:channelId" element={<NetworkChannelsPage />} />
      <Route path="alliances" element={<NetworkAlliancePage />} />
      <Route path="logistics-capability" element={<LogisticsNetworkCapabilityPage />} />
      <Route path="circles" element={<NetworkCirclesPage />} />
      <Route path="group" element={<GroupPage />} />
      <Route path="rfq" element={<NetworkRfqPage />} />
      <Route path="*" element={<Navigate to="/network/directory" replace />} />
    </Routes>
  );
}
